module.exports = __webpack_public_path__ + "files/51967f592528224f51fe116ba7239ba0.png";